import FoodsFlavors from './FoodsFlavors';
import './FoodsFlavors.scss';

export default FoodsFlavors;